import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./spices.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Img4 from "./img4.png";
import Img5 from "./img5.png";
import Sideimg1 from "./sideimg1.png";
import Sideimg2 from "./sideimg2.png";
import Sideimg3 from "./sideimg3.png";
import Sideimg4 from "./sideimg4.png";
import Sideimg5 from "./sideimg5.png";
// import Img1 from "./img1.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";
import SingleRecipiePageRight from "../../components/singleRecipiePage/SingleRecipiePageRight";
const Spices = () => {
  return (
    <>
      <Navb />
      <div className="whiteComponentsingleEcavo spicebg5" id="NANDI_Meat_Masala">
        <SingleRecipiePage
          currrentImg={Img1}
          heading="NANDI Meat Masala"
          text="Nandi's Meat Masala is a symphony of spices, meticulously blended to perfection, enhancing the flavor of every meat dish with its aromatic profile. Crafted with care and expertise, it brings the essence of authentic Indian cuisine to your kitchen. Elevate your cooking experience and delight your taste buds with Nandi's signature Meat Masala."
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/meat-masala-1"
          linkClass="blackButton"
          sideImg={Sideimg1}
          headingcss="blackHeading"
          pcss="blackP"
        />
      </div>
      <div className="whiteComponentsingleEcavoRight spicebg4" id="NANDI_Red_Chilli_Powder">
        <SingleRecipiePageRight
          currrentImg={Img2}
          heading="NANDI Red Chilli Powder"
          text="Imparts a lively red hue to your dish. Widely utilized in Indian cuisine, red chili powder plays a crucial role in crafting chutneys, curries, gravies, and sauces. This quality product is packaged with minimal human intervention."
          sideImg={Sideimg3}
          headingcss="whiteHeading"
          pcss="whiteP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/chilli-powder"
          linkClass="whiteButton"
        />
      </div>
      <div className="whiteComponentsingleEcavo spicebg3" id="NANDI_Coriander_Powder">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Coriander Powder"
          text="Nandi Agro's Coriander Powder, where freshness meets flavor in every sprinkle. Sourced from the finest coriander seeds and ground to perfection, our coriander powder adds depth and aroma to your culinary creations. Whether it's enhancing the flavors of curries, marinades, or spice blends, Nandi Agro's Coriander Powder elevates your dishes to new heights. Discover the essence of quality and taste with every spoonful, brought to you by Nandi Agro's commitment to excellence."
          sideImg={Sideimg2}
          headingcss="blackHeading"
          pcss="blackP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/coriander-powders"
          linkClass="blackButton"
        />
      </div>
      <div className="whiteComponentsingleEcavoRight spicebg1" id="NANDI_Turmeric_Powder">
        <SingleRecipiePageRight
          currrentImg={Img4}
          heading="NANDI Turmeric Powder"
          text="Nandi Agro's Turmeric Powder is a golden treasure, meticulously sourced and crafted to bring the vibrant essence of turmeric to your culinary creations. Our premium-quality powder is rich in curcumin, boasting antioxidant and anti-inflammatory properties that promote overall well-being. Elevate your dishes with the warm, earthy flavor and vibrant color of Nandi Agro's Turmeric Powder, a must-have in every kitchen for both its taste and health benefits."
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/spices-turmeric-powder"
          linkClass="blackButton"
          sideImg={Sideimg4}
          headingcss="blackHeading"
          pcss="blackP"
        />
      </div>
      <div className="whiteComponentsingleEcavo spicebg2" id="NANDI_Sabji_Masala">
        <SingleRecipiePage
          currrentImg={Img5}
          heading="NANDI Sabji Masala"
          text="Nandi Sabji Masala represents an impeccable fusion of handpicked spices sourced from their optimal cultivation regions. The authentic aroma, vibrant color, and distinctive texture of this masala contribute a delightful taste to every dish it enhances. The pure and rich flavors of the spices elevate the taste of your daily vegetables, making them extraordinarily delicious. Nandi Sabji Masala complements a variety of dishes. Beyond just adding flavor, it fulfills your daily requirements for essential nutrients."
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/sabji-masala-10gm-x-15-sachets"
          linkClass="whiteButton"
          sideImg={Sideimg5}
          headingcss="whiteHeading"
          pcss="whiteP"
        />
      </div>
      {/* <SingleRecipiePage /> */}
      <Footer />
    </>
  );
};

export default Spices;
